__turbopack_context__.v({
  "actions": "purchase-module__D69IPq__actions",
  "card": "purchase-module__D69IPq__card",
  "cardEmbedded": "purchase-module__D69IPq__cardEmbedded",
  "countrySelect": "purchase-module__D69IPq__countrySelect",
  "field": "purchase-module__D69IPq__field",
  "fieldFull": "purchase-module__D69IPq__fieldFull",
  "form": "purchase-module__D69IPq__form",
  "formGrid": "purchase-module__D69IPq__formGrid",
  "helpButton": "purchase-module__D69IPq__helpButton",
  "homeLink": "purchase-module__D69IPq__homeLink",
  "homeLinkRow": "purchase-module__D69IPq__homeLinkRow",
  "input": "purchase-module__D69IPq__input",
  "label": "purchase-module__D69IPq__label",
  "otpInput": "purchase-module__D69IPq__otpInput",
  "page": "purchase-module__D69IPq__page",
  "pageEmbedded": "purchase-module__D69IPq__pageEmbedded",
  "phoneRow": "purchase-module__D69IPq__phoneRow",
  "primaryButton": "purchase-module__D69IPq__primaryButton",
  "section": "purchase-module__D69IPq__section",
  "sectionEmbedded": "purchase-module__D69IPq__sectionEmbedded",
  "selectIcon": "purchase-module__D69IPq__selectIcon",
  "selectWrap": "purchase-module__D69IPq__selectWrap",
  "shell": "purchase-module__D69IPq__shell",
  "shellEmbedded": "purchase-module__D69IPq__shellEmbedded",
  "status": "purchase-module__D69IPq__status",
  "statusError": "purchase-module__D69IPq__statusError",
  "statusSuccess": "purchase-module__D69IPq__statusSuccess",
  "successBody": "purchase-module__D69IPq__successBody",
  "successParagraph": "purchase-module__D69IPq__successParagraph",
  "title": "purchase-module__D69IPq__title",
});
